<h2 class="ap-green content-block">Authorization Error</h2>
<p class="content-block">You are not authorized to access this application. Please contact one of the administrative below to provide the
  appropriate access.</p>
<div class="content-block">
  <div class="dx-card responsive-paddings">
    <h4 class="ap-green home-sub-heading">Merchant</h4>
    <div class="logos-container">      
      <p class="welcome-message" *ngIf="homePageData" [innerHTML]="homePageData.merchantContacts"></p>
    </div>
    <h4 class="ap-green home-sub-heading">Tonnage</h4>    
    <p class="welcome-message" *ngIf="homePageData" [innerHTML]="homePageData.tonnageContacts"></p>
  </div>
</div>